import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-528c0338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-b-declaration" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h3 class=\"mt-3 mb-3\" data-v-528c0338>Declaration</h3><div class=\"col-12 declarations mt-4\" data-v-528c0338> By clicking “Submit” I declare that:<br data-v-528c0338><br data-v-528c0338> The contents of this submission are true and correct; and<br data-v-528c0338><br data-v-528c0338> I have read the <a class=\"link\" href=\"https://www.lawsociety.com.au/privacy-policy/personal-information-collection-notice\" target=\"_blank\" data-v-528c0338>Personal Information Collection Notice</a> and consent to The Law Society of New South Wales collection, use and disclosure of information in accordance with that Notice; and </div><div class=\"col-12 declarations mt-4\" data-v-528c0338> The Law Society has been advised of all known instances of non-compliance or suspected non-compliance with the provisions of the Uniform Law and the Uniform Rules, and all known data breaches, cyber security breaches, fraud or suspected fraud during the relevant period. </div><p data-v-528c0338></p><h4 data-v-528c0338>Additional Information <span style=\"font-family:&#39;open sans&#39;;\" data-v-528c0338>(Optional)</span></h4><div data-v-528c0338> Information provided below does not form part of the Part B submission and will not be disclosed to your External Examiner:</div><p data-v-528c0338></p><h4 data-v-528c0338>What is the estimated cost of your examination?</h4>", 8)
const _hoisted_10 = {
  class: "input-box col-6 ml-4",
  style: {"position":"relative"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dollar-sign" }, "$", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "What date did you provide all of your records to your external examiner?", -1))
const _hoisted_14 = { class: "ml-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Completer:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Submission date:", -1))
const _hoisted_20 = {
  key: 0,
  class: "col-12 declarations mt-4"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle" }, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "col-12 declarations mt-4"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle" }, null, -1))

export function render(_ctx, _cache) {
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")
  const _component_date_picker = _resolveComponent("date-picker")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent && !_ctx.errorLoadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_CurrencyInput, {
              class: "amount pr-3",
              modelValue: _ctx.examinationCost,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.examinationCost) = $event)),
              options: {  currency: 'USD', currencyDisplay: 'hidden', precision: 2}
            }, null, 8, ["modelValue"]),
            _hoisted_11
          ]),
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_date_picker, {
              value: _ctx.recordsProvidedOn,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.recordsProvidedOn) = $event)),
              format: "DD/MM/YYYY",
              "input-class": "examiner-date"
            }, null, 8, ["value"])
          ]),
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", null, _toDisplayString(_ctx.completer), 1),
          _hoisted_18,
          _hoisted_19,
          _createElementVNode("div", null, _toDisplayString(_ctx.$formatDateFullDate(new Date())), 1),
          (!_ctx.formPartBData?.declarationDetails?.isPrincipal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createTextVNode(" To submit this compliance form, you must be a Principal. ")
              ]))
            : (!_ctx.formPartBData?.declarationDetails?.hasTrustCoordinator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createTextVNode(" To submit this compliance form, a Trust Coordinator must be assigned for this Practice. A Principal can assign themselves as a Trust Coordinator on the initial dashboard page. ")
                ]))
              : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}